<a href="#" (click)="startTour()" [hidden]="hideRestartLink">Start Tour</a>
